import { emailRegex, nameRegex, telephoneRegex } from './regex.ts';

export const RULES = {
  email: {
    required: 'El correo es requerido',
    maxLength: {
      value: 30,
      message: 'El correo no puede exceder 30 caracteres',
    },
    pattern: {
      value: emailRegex,
      message: 'Email inválido',
    },
  },
  password: {
    required: 'La contraseña es requerida',
    minLength: {
      value: 8,
      message: 'La contraseña debe tener al menos 8 caracteres',
    },
  },
  telephone: {
    required: 'El teléfono es requerido',
    maxLength: {
      value: 10,
      message: 'El teléfono debe tener 10 dígitos',
    },
    pattern: {
      value: telephoneRegex,
      message: 'El teléfono debe contener solo números',
    },
  },
  name: {
    required: 'El nombre es requerido',
    maxLength: {
      value: 50,
      message: 'El nombre no puede exceder 50 caracteres',
    },
    pattern: {
      value: nameRegex,
      message: 'El nombre solo puede contener letras y espacios',
    },
  },
  otp: {
    required: 'El código es requerido',
    minLength: {
      value: 4,
      message: 'Debe contener 4 dígitos',
    },
    maxLength: {
      value: 4,
      message: 'Debe contener 4 dígitos',
    },
  },
};
